import { ListOverlay, Row } from './ListOverlay.js';
import { dia } from '../lib/fechas.js';
import type { SessionState } from '../lib/session.js';
import { eurosCompacto } from '../lib/etiquetas-metricas.js';

interface OppRow {
  id: string; ghl_opportunity_id: string; name: string | null;
  status: string | null; monetary_value: number | null;
  assigned_user_email: string | null;
  /** Nombre de la persona asignada (o "Sin asignar"). */
  persona?: string;
  stage_name: string | null;
  created_at_ghl: string | null; updated_at_ghl: string | null;
  ghl_contact_id: string | null;
}

interface Props {
  session: SessionState;
  stage: string;
  /** El filtro que aplico el snapshot (sus personas; el embudo es lo abierto AHORA). */
  filtro: URLSearchParams;
  locationId: string | null;
}

function fmtEur(n: number | null): string {
  if (!n) return '-';
  return eurosCompacto(n);
}

export function OpportunitiesList({ session, stage, filtro, locationId }: Props) {
  const q = new URLSearchParams(filtro);
  q.set('stage', stage);
  q.set('max', '500');
  const path = `/api/dashboard/opportunities?${q.toString()}`;
  return (
    <ListOverlay<OppRow>
      session={session}
      title={`Oportunidades · ${stage}`}
      subtitle="abiertas ahora"
      fetchPath={path}
      itemsKey="opportunities"
      emptyMessage={`Sin oportunidades abiertas en la etapa "${stage}".`}
      onItemClick={(o) => {
        if (locationId && o.ghl_contact_id) {
          window.open(`https://app.gohighlevel.com/v2/location/${locationId}/contacts/detail/${o.ghl_contact_id}`, '_blank', 'noopener');
        }
      }}
      renderRow={(o) => (
        <Row
          left={<>
            <div className="row-title">{o.name ?? '(sin nombre)'}</div>
            <div className="row-sub">{o.persona ?? o.assigned_user_email ?? 'Sin asignar'}</div>
          </>}
          aside={<>
            <div style={{ fontWeight: 600 }}>{fmtEur(o.monetary_value)}</div>
            <div>{dia(o.updated_at_ghl ?? o.created_at_ghl ?? '')}</div>
          </>}
        />
      )}
    />
  );
}
